import { useTranslation } from "react-i18next";

import { BackLink } from "@/components/BackLink";
import { FaqSection, FinalCtaSection } from "@/components/marketing/Sections";
import { PricingDetails, PricingSection } from "@/components/marketing/PricingSection";
import { usePageMeta } from "@/lib/seo";
import { BRAND } from "@/config/brand";

export default function Pricing() {
  const { t } = useTranslation();
  usePageMeta({ title: `${t("pricing.eyebrow")} — ${BRAND.name}`, description: t("pricing.note"), localized: true });
  return (
    <div data-testid="pricing-page">
      <div className="max-w-[980px] mx-auto px-6 pt-10">
        <BackLink fallback="/" testid="pricing-back-link" />
      </div>
      <PricingSection showCta={false} HeadingTag="h1" />
      <PricingDetails />
      <FaqSection />
      <FinalCtaSection />
    </div>
  );
}
